import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import { UseWalletProvider } from 'use-wallet'
import { Web3ReactProvider } from '@web3-react/core';
import * as React from 'react';
import { createContext, useContext } from 'react';
import Web3 from 'web3';
var initialState = {
  platforms: [],
  tokens: [],
  baseLpTokens: {}
};
var PlatformContext = /*#__PURE__*/createContext(initialState);
export var usePlatform = function usePlatform() {
  return useContext(PlatformContext);
};
export var PlatformProvider = function PlatformProvider(_ref) {
  var children = _ref.children,
      _ref$platforms = _ref.platforms,
      platforms = _ref$platforms === void 0 ? [] : _ref$platforms,
      _ref$tokens = _ref.tokens,
      tokens = _ref$tokens === void 0 ? [] : _ref$tokens,
      _ref$baseLpTokens = _ref.baseLpTokens,
      baseLpTokens = _ref$baseLpTokens === void 0 ? {} : _ref$baseLpTokens;
  var formatPlatforms = React.useMemo(function () {
    return platforms.map(function (platform) {
      var _platform$image;

      var logo = platform.logo;
      if (platform !== null && platform !== void 0 && platform.image) logo = "".concat(process.env.NEXT_PUBLIC_CMS_URL).concat(platform === null || platform === void 0 ? void 0 : (_platform$image = platform.image) === null || _platform$image === void 0 ? void 0 : _platform$image.url);
      return _objectSpread(_objectSpread({}, platform), {}, {
        logo: logo
      });
    });
  }, [platforms]);
  var formatTokens = React.useMemo(function () {
    return tokens.map(function (token) {
      var _token$image;

      var logo = token.logo;
      if (token !== null && token !== void 0 && token.image) logo = "".concat(process.env.NEXT_PUBLIC_CMS_URL).concat(token === null || token === void 0 ? void 0 : (_token$image = token.image) === null || _token$image === void 0 ? void 0 : _token$image.url);
      return _objectSpread(_objectSpread({}, token), {}, {
        logo: logo
      });
    });
  }, [tokens]);

  var mapLPFotmat = function mapLPFotmat(lpToken) {
    var _lpToken$image;

    var logo = lpToken.logo;
    if (lpToken !== null && lpToken !== void 0 && lpToken.image) logo = "".concat(process.env.NEXT_PUBLIC_CMS_URL).concat(lpToken === null || lpToken === void 0 ? void 0 : (_lpToken$image = lpToken.image) === null || _lpToken$image === void 0 ? void 0 : _lpToken$image.url);
    return _objectSpread(_objectSpread({}, lpToken), {}, {
      logo: logo
    });
  };

  var formatLpTokens = React.useMemo(function () {
    var _baseLpTokens$56$map, _baseLpTokens$, _baseLpTokens$137$map, _baseLpTokens$2;

    baseLpTokens[56] = (_baseLpTokens$56$map = (_baseLpTokens$ = baseLpTokens[56]) === null || _baseLpTokens$ === void 0 ? void 0 : _baseLpTokens$.map(mapLPFotmat)) !== null && _baseLpTokens$56$map !== void 0 ? _baseLpTokens$56$map : [];
    baseLpTokens[137] = (_baseLpTokens$137$map = (_baseLpTokens$2 = baseLpTokens[137]) === null || _baseLpTokens$2 === void 0 ? void 0 : _baseLpTokens$2.map(mapLPFotmat)) !== null && _baseLpTokens$137$map !== void 0 ? _baseLpTokens$137$map : [];
    return baseLpTokens;
  }, [baseLpTokens]);
  return _jsx(PlatformContext.Provider, {
    value: {
      platforms: formatPlatforms,
      tokens: formatTokens,
      baseLpTokens: formatLpTokens
    },
    children: _jsx(Web3ReactProvider, {
      getLibrary: function getLibrary(provider) {
        return new Web3(provider);
      },
      children: children
    })
  });
};